import * as Cookie from './cookie';
import * as Form from './form';

const formElement = document.querySelector('[data-garbage-calendar-form]');
const formResults = document.querySelector('[data-garbage-calendar-results]');
const downloadLink = document.querySelector('[data-garbage-calendar-download]');
const noticeElement = document.querySelector('[data-notice]');

export function addContents(json) {
    let formResultsHtml = formResults.innerHTML;

    if (json.length > 0) {
        formResultsHtml = '<ul class="garbage-list">';

        Object.keys(json).forEach((item) => {
            const collectDate = new Date(json[item].date);
            const viewDate = `${collectDate.toLocaleString('nl-NL', { weekday: 'long' })}: ${collectDate.getDate()}-${parseInt(collectDate.getMonth()) + 1}`;
            formResultsHtml += `<li>
                                    <span>
                                        <span class="icon">
                                            <svg role="img" class="svg--garbage-calendar-${json[item].type}" aria-hidden="true">
                                                <use xlink:href="/img/custom/svg/sprite.svg#garbage-calendar-${json[item].type}"></use>
                                            </svg>
                                        </span>
                                        <span class="date">${viewDate}</span>
                                    </span> <span>${json[item].nameType}</span>
                                </li>`;
        });

        formResultsHtml += '</ul>';

        formResults.innerHTML = formResultsHtml;
        formResults.setAttribute('aria-hidden', 'false');

        downloadLink.classList.remove('hidden');
        downloadLink.setAttribute('aria-hidden', 'false');

        downloadLink.children[0].setAttribute('href', `https://www.mijnafvalwijzer.nl/site/rawpost/${new Date().getFullYear()}/${formElement.querySelector('[name="postal-code"]').value.replace(/\s/g, '')}/${formElement.querySelector('[name="house-number"]').value}/`);
    }

    Cookie.set('postal-code', formElement.querySelector('[name="postal-code"]').value);
    Cookie.set('house-number', formElement.querySelector('[name="house-number"]').value);
    Cookie.set('house-number-addition', formElement.querySelector('[name="house-number-addition"]').value);
}

export function resetGarbageCalendarForm() {
    formResults.setAttribute('aria-hidden', 'true');
    formResults.innerHTML = '';

    Form.hideNotice(formElement, noticeElement);
}

export function sendFormData() {
    if (formElement.hasAttribute('data-redirect')) {
        Cookie.set('postal-code', formElement.querySelector('[name="postal-code"]').value);
        Cookie.set('house-number', formElement.querySelector('[name="house-number"]').value);
        Cookie.set('house-number-addition', formElement.querySelector('[name="house-number-addition"]').value);

        document.location.href = `${formElement.getAttribute('data-redirect')}`;
    } else {
        const Request = new XMLHttpRequest();
        Request.open(formElement.method, formElement.action);
        Request.setRequestHeader('Accept', 'application/json');
        formElement.setAttribute('aria-busy', 'true');

        resetGarbageCalendarForm();

        let called = false;
        Request.onreadystatechange = () => {
            if (Request.readyState === XMLHttpRequest.DONE && !called) {
                if (Request.status === 0 || (Request.status >= 200 && Request.status < 400)) {
                    const jsonResponse = JSON.parse(Request.responseText);

                    if (jsonResponse.invalidPostalCode) {
                        Form.showNotice(noticeElement, 'Deze postcode bevindt zich buiten uw geselecteerde gemeente, pas uw geselecteerde gemeente aan.');
                    } else {
                        addContents(JSON.parse(Request.responseText));
                    }
                } else if (Request.status === 422) {
                    Object.keys(JSON.parse(Request.responseText).errors)
                        .forEach((item) => {
                            Form.invalidateInputs(formElement, item);
                            // eslint-disable-next-line max-len
                            Form.showNotice(noticeElement, JSON.parse(Request.responseText).errors[item]);
                        });
                } else {
                    Form.showNotice(noticeElement, 'Er is geen afvalkalender gevonden voor deze postcode.');
                }

                called = true;
                formElement.setAttribute('aria-busy', 'false');
            }
        };

        Request.send(new FormData(formElement));
    }
}

export default function initGarbageCalendarSearch() {
    if (formElement) {
        const cookiePostalCode = Cookie.get('postal-code');
        const cookieHouseNumber = Cookie.get('house-number');
        const cookieHouseNumberAddition = Cookie.get('house-number-addition');

        formElement.querySelector('[name="postal-code"]').value = cookiePostalCode;
        formElement.querySelector('[name="house-number"]').value = cookieHouseNumber;
        formElement.querySelector('[name="house-number-addition"]').value = cookieHouseNumberAddition;

        formElement.addEventListener('submit', (e) => {
            e.stopPropagation();
            e.preventDefault();

            sendFormData();
        });

        if (cookiePostalCode && cookieHouseNumber && !formElement.hasAttribute('data-redirect')) {
            sendFormData();
        }
    }
}
